import { Component, OnInit, Output, EventEmitter, Input, Optional } from '@angular/core';
import { AppService } from '@root/app.service';
import { InternationalService } from '@root/international.service';
import _ from 'lodash';
import { NzModalRef } from 'ng-zorro-antd/modal';
@Component({
  selector: 'host-qrcode-download',
  templateUrl: './qrcode-download.component.html',
  styleUrls: ['./qrcode-download.component.scss'],
})
export class QrcodeDownloadComponent implements OnInit {
  @Output() onClose = new EventEmitter();

  get downloadInfo() {
    return this.international.getDownloadInfo();
  }

  get isGlobal() {
    return this.app.app.international;
    // return this.international.isInternational();
  }

  constructor(
    private app: AppService,
    private international: InternationalService,
    @Optional() private ref: NzModalRef
  ) {}

  ngOnInit() {}

  close() {
    this.onClose.emit();
    if (this.ref) {
      this.ref.close();
    }
  }
}
